import React, { useState, useEffect } from "react";
import s from "./AnimatedImages.module.css";
import { motion, AnimatePresence } from "framer-motion";
// первый набор картинок
import banner1_1 from "../../assets/bannerImages/banner1_1.jpg";
import banner1_2 from "../../assets/bannerImages/banner1_2.jpg";
import banner1_3 from "../../assets/bannerImages/banner1_3.jpg";
// import banner1_4 from "../../assets/bannerImages/banner1_4.jpg";
// import banner1_5 from "../../assets/bannerImages/banner1_5.jpg";
// Второй набор картинок
import banner2_1 from "../../assets/bannerImages/banner2_1.jpg";
import banner2_2 from "../../assets/bannerImages/banner2_2.jpg";
import banner2_3 from "../../assets/bannerImages/banner2_3.jpg";
// import banner2_4 from "../../assets/bannerImages/banner2_4.jpg";
// import banner2_5 from "../../assets/bannerImages/banner2_5.jpg";

// Третий набор картинок
import banner3_1 from "../../assets/bannerImages/banner3_1.jpg";
import banner3_2 from "../../assets/bannerImages/banner3_2.jpg";
import banner3_3 from "../../assets/bannerImages/banner3_3.jpg";
// import banner3_4 from "../../assets/bannerImages/banner3_4.jpg";
// import banner3_5 from "../../assets/bannerImages/banner3_5.jpg";

const imageSets = [
  [banner1_1, banner1_2, banner1_3], // Первый набор
  [banner2_1, banner2_2, banner2_3], // Второй набор
  [banner3_1, banner3_2, banner3_3], // Третий набор
];

export default function AnimatedImages() {
  const [currentSetIndex, setCurrentSetIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(true);
  const [showText, setShowText] = useState(true);

  useEffect(() => {
    const firstTextTimer = setTimeout(() => {
      setShowText(true);
    }, 1500); // Уменьшил до 1.5 секунд

    const interval = setInterval(() => {
      // Сначала скрываем текст
      setShowText(false);

      // Затем останавливаем анимацию картинок
      setIsAnimating(false);

      // Ждем завершения анимации исчезновения картинок
      setTimeout(() => {
        setCurrentSetIndex((prev) => (prev + 1) % imageSets.length);

        // Пауза после отлета - уменьшил до 1.5 секунд
        setTimeout(() => {
          setIsAnimating(true);

          // Показываем текст быстрее - через 1 секунду
          setTimeout(() => {
            setShowText(true);
          }, 1000); // ← Уменьшил до 1 секунды
        }, 1500); // ← Уменьшил паузу после отлета
      }, 1000); // ← Уменьшил время ожидания исчезновения
    }, 7000); // ← Уменьшил общий интервал до 7 секунд

    return () => {
      clearTimeout(firstTextTimer);
      clearInterval(interval);
    };
  }, []);

  const currentImages = imageSets[currentSetIndex];

  return (
    <div className={s.wrapper}>
      <AnimatePresence>
        {isAnimating &&
          currentImages.map((src, index) => {
            const grayscaleValue = 100 - index * 20;
            // const leftOffset = index * 20;
            const leftOffset = index * 33.3;

            return (
              <motion.div
                key={`${currentSetIndex}-${index}`}
                className={s.imageContainer}
                initial={{ opacity: 0, x: 800 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -800 }}
                transition={{
                  delay: index * 0.3, // ← Уменьшил задержку
                  duration: 0.8, // ← Уменьшил длительность
                  ease: "easeOut",
                }}
                style={{
                  zIndex: index + 1,
                  left: `${leftOffset}%`,
                  filter: `grayscale(${grayscaleValue}%) brightness(90%)`,
                }}
              >
                <img
                  src={src}
                  alt={`Баннер ${currentSetIndex + 1}-${index + 1}`}
                  className={s.image}
                />
              </motion.div>
            );
          })}
      </AnimatePresence>

      <AnimatePresence>
        {showText && (
          <motion.div
            className={s.textOverlay}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{
              duration: 0.6, // ← Уменьшил длительность
            }}
          >
            <div className={s.textContent}>
              <div className={s.nameRow}>
                <h2 className={s.nameWhite}>I'm</h2>
                <h2 className={s.nameBlack}>Morozov Ivan</h2>
              </div>
              <p className={s.description}>
                "From canvas to interiors, welcome to my creative spaces."
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
